import { motion } from "framer-motion";
import Logo from "@/components/ui/Logo";

export default function PageLoader() {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-[var(--bg-void)] transition-colors duration-700">
      <motion.div
        animate={{ scale: [1, 1.1, 1], opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
      >
        <Logo variant="default" />
      </motion.div>
      
      <div className="mt-8 flex gap-1">
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-[var(--nily-teal)]"
            animate={{ opacity: [0.2, 1, 0.2] }}
            transition={{ duration: 1, repeat: Infinity, delay: i * 0.2 }}
          />
        ))}
      </div>
      <p className="mt-4 text-[10px] font-mono text-[var(--text-muted)] uppercase tracking-widest">
        Loading Module...
      </p>
    </div>
  );
}
